import React from 'react';
import { Grid } from '@material-ui/core';
import {
  Edit,
  SimpleForm,
  TextInput,
  ImageField,
  ImageInput,
  SelectInput,
  ReferenceInput,
  required,
} from 'react-admin';
import Toolbar from '../resource-toolbar';
import ImagePreview from '../image-preview';
import { LanguageChanger } from '../fields';
import { useServerValidation, useLanguageChange, getStyle } from '../../helpers';
import { PROD_STATUSES, LANGUAGES } from '../../constants';

const WithProps = ({ children, ...props }) => children(props);

export default (props) => {
  const { onFailure } = useServerValidation();
  const [defaultLanguage] = LANGUAGES;
  const { language, onLanguageChange } = useLanguageChange(defaultLanguage);
  return (
    <Grid item lg={6} md={8} xs={12}>
      <Edit {...props} onFailure={onFailure} undoable={false}>
        <WithProps>
          {({ record, ...props }) => {
            if (record.parent_id === null)
              return (
                <SimpleForm
                  record={record}
                  {...props}
                  toolbar={<Toolbar resourceName="categories" />}
                >
                  <SelectInput
                    source="status"
                    choices={PROD_STATUSES}
                    fullWidth
                    defaultValue="New"
                    validate={required()}
                  />
                  <ImageInput source="files" label="Photo" accept="image/*">
                    <ImageField source="photo" title="Category Photo" />
                  </ImageInput>
                  <ImagePreview source="preview_image_url" />
                  <LanguageChanger language={language} onLanguageChange={onLanguageChange} />
                  <TextInput style={getStyle(language, '_en')} source="name" fullWidth validate={required()} />
                  <TextInput style={getStyle(language, '_fr')} source="name_fr" fullWidth />
                  <TextInput style={getStyle(language, '_jp')} source="name_jp" fullWidth />
                  <TextInput style={getStyle(language, '_cn')} source="name_cn" fullWidth />
                  <TextInput style={getStyle(language, '_de')} source="name_de" fullWidth />
                  <TextInput style={getStyle(language, '_kr')} source="name_kr" fullWidth />
                  <TextInput style={getStyle(language, '_es')} source="name_es" fullWidth />
                </SimpleForm>
              );
            return (
              <SimpleForm
                record={record}
                {...props}
                toolbar={<Toolbar resourceName="categories" />}
              >
                <SelectInput
                  source="status"
                  choices={PROD_STATUSES}
                  fullWidth
                  defaultValue="New"
                  validate={required()}
                />
                <ReferenceInput
                  source="parent_id"
                  reference="categories"
                  filter={{ parent_id: null }}
                  sort={{ field: 'name', order: 'ASC' }}
                  fullWidth
                >
                  <SelectInput optionText="name" validate={required()} />
                </ReferenceInput>
                <ImageInput source="files" label="Photo" accept="image/*">
                  <ImageField source="photo" title="Category Photo" />
                </ImageInput>
                <ImagePreview source="preview_image_url" withDelete />
                <TextInput source="name" fullWidth validate={required()} />
                <TextInput source="name_fr" fullWidth />
                <TextInput source="name_jp" fullWidth />
                <TextInput source="name_cn" fullWidth />
                <TextInput source="name_de" fullWidth />
                <TextInput source="name_kr" fullWidth />
                <TextInput source="name_es" fullWidth />
              </SimpleForm>
            );
          }}
        </WithProps>
      </Edit>
    </Grid>
  );
};
